import React, { useState } from "react";
import { Col, Row, Modal, Form, Input, Select, Button, Divider } from "antd";
import useCommonsService from "../../../../services/useCommonsService";

export const CompleteInformationModal = ({
  visible,
  form,
  onSubmit,
  isLoading,
}) => {
  const [selectedCityId, setSelectedCityId] = useState(null);

  const { cities, isLoadingCities, useDistricts } = useCommonsService();

  // Get districts based on selected city
  const { data: districts, isLoading: isLoadingDistricts } =
    useDistricts(selectedCityId);

  const handleCityChange = (value) => {
    setSelectedCityId(value);
    form.setFieldValue("district", undefined);
  };
  if (!visible) {
    return;
  }

  return (
    <Modal
      loading={isLoading}
      style={{ minWidth: 800 }}
      title="Son Bir Adım"
      open={visible}
      closable={false}
      footer={null}
      maskClosable={false}>
      <Form
        form={form}
        layout="vertical"
        onFinish={onSubmit}
        style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <Divider orientation="left"> Şirket Bilgileri</Divider>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <Form.Item
              label="Şirket Adı"
              name="companyName"
              rules={[
                { required: true, message: "Lütfen şirket adını giriniz" },
              ]}>
              <Input placeholder="Şirket Adı" />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              label="VKN"
              name="taxNo"
              rules={[
                {
                  required: true,
                  message: "Lütfen VKN numaranızı giriniz",
                },
                {
                  len: 10,
                  message: "VKN numarası 10 haneli olmalıdır",
                },
              ]}>
              <Input placeholder="VKN" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <Form.Item
              label="Şehir"
              name="city" // Changed from district to city
              rules={[
                {
                  required: true,
                  message: "Lütfen Şehir seçiniz",
                },
              ]}>
              <Select
                loading={isLoadingCities}
                options={cities}
                placeholder="Şehir"
                onChange={handleCityChange}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="İlçe"
              name="district"
              rules={[
                {
                  required: true,
                  message: "Lütfen İlçe seçiniz",
                },
              ]}>
              <Select
                loading={isLoadingDistricts}
                options={districts}
                placeholder="İlçe"
                disabled={!selectedCityId}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <Form.Item
              label="Vergi Dairesi "
              name="taxOffice"
              rules={[
                { required: true, message: "Lütfen vergi dairesi giriniz" },
              ]}>
              <Input placeholder="Vergi Dairesi" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="Açık Adres "
              name="address"
              rules={[
                { required: true, message: "Lütfen açık adres giriniz" },
              ]}>
              <Input.TextArea rows={4} placeholder="Adres Tanımı" />
            </Form.Item>
          </Col>
        </Row>

        <Button
          loading={isLoading}
          style={{ marginTop: 25 }}
          type="primary"
          htmlType="submit"
          block>
          Bilgileri Kaydet
        </Button>
      </Form>
    </Modal>
  );
};
